/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Glyphicon, Modal } from "react-bootstrap";

class CancelAction extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
      cancelling: false,
      errors: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCancelRunsheet = () => {
    this.setState({ cancelling: true });
    this.props
      .cancelRunsheet(this.props.runsheet.id)
      .then(() => this.handleClose())
      .catch(() => this.setState({ errors: true }));
  };

  render() {
    return (
      <div style={{ display: "inline" }}>
        <span className="remove-runsheet">
          <Glyphicon glyph="trash" onClick={this.handleShow} title="Cancel" />
        </span>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              Cancel Runsheet: {this.props.runsheet.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errors && (
              <p className="bg-danger">Error: Unable to cancel runsheet</p>
            )}
            <p>
              Are you sure you want to cancel this runsheet? This action cannot
              be undone
            </p>
          </Modal.Body>
          <Modal.Footer>
            {this.state.cancelling ? (
              <Button bsStyle="danger" disabled>
                Cancelling Runsheet...
              </Button>
            ) : (
              <Button bsStyle="danger" onClick={this.handleCancelRunsheet}>
                Cancel Runsheet
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
CancelAction.propTypes = {
  runsheet: PropTypes.object.isRequired,
  cancelRunsheet: PropTypes.func.isRequired
};

export default CancelAction;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetCancel.js